import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleTransferProjects(
  state: State,
  { projects, destination }: Boundaries["transferProjects"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    zones: req.zones.map((z) =>
      z.uuid === destination.uuid
        ? {
            ...z,
            projects: [...z.projects, ...projects],
          }
        : z,
    ),
  }));
}
export { handleTransferProjects };
